export const apiErrors = {
  userName: 'Username already exists',
  customerError409: 'Customer with such name already exists',
}
